"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimeInfoHelper = void 0;
var dayjs_1 = __importDefault(require("dayjs"));
var utc_1 = __importDefault(require("dayjs/plugin/utc"));
var TimeInfoTypes;
(function (TimeInfoTypes) {
    TimeInfoTypes["SECOND"] = "second";
    TimeInfoTypes["MINUTE"] = "minute";
    TimeInfoTypes["HOUR"] = "hour";
    TimeInfoTypes["DAY"] = "day";
    TimeInfoTypes["WEEK"] = "week";
    TimeInfoTypes["MONTH"] = "month";
    TimeInfoTypes["YEAR"] = "year";
})(TimeInfoTypes || (TimeInfoTypes = {}));
var TimeInfoHelper = /** @class */ (function () {
    function TimeInfoHelper() {
        this.defaultTimeFormat = 'YYYY-MM-DD HH:mm:ss';
        dayjs_1.default.extend(utc_1.default);
    }
    TimeInfoHelper.prototype.getInfo = function (date) {
        var unixTimeAt = dayjs_1.default.utc(date, this.defaultTimeFormat).local().unix();
        var currentUnixTime = dayjs_1.default().local().unix();
        var seconds = currentUnixTime - unixTimeAt;
        switch (true) {
            case (seconds < 0):
                return {
                    amount: 0,
                    type: TimeInfoTypes.SECOND
                };
            case (seconds < 60):
                return {
                    amount: seconds,
                    type: TimeInfoTypes.SECOND
                };
            case (seconds < 3600):
                return {
                    amount: Math.floor(seconds / 60),
                    type: TimeInfoTypes.MINUTE
                };
            case (seconds < 86400):
                return {
                    amount: Math.floor(seconds / 3600),
                    type: TimeInfoTypes.HOUR
                };
            case (seconds < 604800):
                return {
                    amount: Math.floor(seconds / 86400),
                    type: TimeInfoTypes.DAY
                };
            case (seconds < 25056e2):
                return {
                    amount: Math.floor(seconds / 604800),
                    type: TimeInfoTypes.WEEK
                };
            case (seconds < 31536e3):
                return {
                    amount: Math.floor(seconds / 2592e3),
                    type: TimeInfoTypes.MONTH
                };
            case (seconds > 31536e3):
                return {
                    amount: Math.floor(seconds / 31536e3),
                    type: TimeInfoTypes.YEAR
                };
        }
        throw new Error('Unknown time info');
    };
    return TimeInfoHelper;
}());
exports.TimeInfoHelper = TimeInfoHelper;
